<input
  type="checkbox"
  [id]="id()"
  [checked]="checked()"
  [disabled]="disabledState()"
  [indeterminate]="indeterminate()"
  (change)="handleCheckboxChange($event)"
  (blur)="handleCheckboxBlur()"
  class="tw:sr-only tw:peer"
  aria-label="Checkbox"
  role="checkbox"
  [attr.aria-checked]="checkedValue()"
  [attr.aria-disabled]="disabledState()"
  [attr.aria-labelledby]="`${id()}-label`"
/>

<label [for]="id()" [ngClass]="checkboxLabelClasses()" [attr.id]="`${id()}-label`">
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    [ngClass]="checkboxClasses()"
    aria-hidden="true"
    class="tw:shrink-0"
  >
    @if (checkedValue() === false) {
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4 6C4 4.89543 4.89543 4 6 4H18C19.1046 4 20 4.89543 20 6V18C20 19.1046 19.1046 20 18 20H6C4.89543 20 4 19.1046 4 18V6ZM18 6L6 6V18H18V6Z"
        fill="currentColor"
      />
    } @else if (checkedValue() === true) {
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6 4C4.89543 4 4 4.89543 4 6V18C4 19.1046 4.89543 20 6 20H18C19.1046 20 20 19.1046 20 18V6C20 4.89543 19.1046 4 18 4H6ZM16.7747 9.13238C17.1239 8.70454 17.0602 8.07459 16.6324 7.72534C16.2045 7.37609 15.5746 7.43979 15.2253 7.86762L10.2179 14.0017L8.71436 12.4669C8.32788 12.0724 7.69475 12.0658 7.30022 12.4523C6.90569 12.8388 6.89916 13.4719 7.28564 13.8664L9.57136 16.1998C9.77046 16.403 10.0467 16.5118 10.3309 16.499C10.6152 16.4861 10.8805 16.3528 11.0604 16.1324L16.7747 9.13238Z"
        fill="currentColor"
      />
    } @else {
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4 6C4 4.89543 4.89543 4 6 4H18C19.1046 4 20 4.89543 20 6V18C20 19.1046 19.1046 20 18 20H6C4.89543 20 4 19.1046 4 18V6ZM18 6L6 6V18H18V6Z"
        fill="currentColor"
      />
      <rect x="8" y="11" width="8" height="2" rx="1" fill="currentColor" />
    }
  </svg>
  <span>
    <ng-content></ng-content>
  </span>
</label>
